import {
	useDisclosure,
	HStack,
	VStack,
	Spacer,
 } from '@chakra-ui/react';
 import ButtonOnlyIcon from '../Button/Only-icon';
 import React from 'react';
 import EditQuestionModal from '../Modals/EditQuestionModal';

const EditQuestionCard = ({ index, question, remove, editQuestion, children, moveCard, QuestionComponent }) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	// EG-41: o botão "Desfazer Edição" foi removido a pedido do dev. Com ele
	// saíram o snapshot initialQuestion e o sinalizador isEdited, que existiam
	// só para alimentá-lo — e o efeito que mutava question.options no meio do
	// caminho. O card voltou a ser apenas apresentação mais o repasse da edição.
	const handleEdit = (updatedQuestion, index, meta) => {
		// meta carrega o que só o modal sabe — se a edição foi apenas de
		// classificação. Sem repassar, a informação morre aqui.
		editQuestion(updatedQuestion, index, meta);
	}

  return (
    <VStack
			spacing={['16px', '24px']}
			p='6'
			pt='4'
			pb='26px'
			bg='white'
			borderRadius='12px'
			border='2px solid #EAEEF0'
			pos='relative'
			gap={0}
			>
			<HStack width={'full'} justifyContent={'space-between'}>
				{moveCard ? (
					<HStack>
						<ButtonOnlyIcon
							name='iconArrowDown'
							h='24px'
							w='24px'
							borderRadius='50%'
							bgColor='gray.100'
							variant='outline'
							onClick={() => moveCard('down', question.index)}
						/>
						<ButtonOnlyIcon
							name='iconArrowUp'
							h='24px'
							w='24px'
							borderRadius='50%'
							bgColor='gray.100'
							variant='outline'
							onClick={() => moveCard('up', question.index)}
						/>
					</HStack>
				):(
					<Spacer />
				)}
				<HStack>
					{editQuestion &&
						<>
							{/* EG-41: IconButton sem rótulo acessível não é anunciado por
								leitor de tela e não é alcançável por teste de navegação —
								o ícone tem alt vazio de propósito, então o nome precisa
								vir daqui. */}
							<ButtonOnlyIcon
								name='edit'
								h='32px'
								aria-label='Editar pergunta'
								onClick={onOpen}
							/>
							<EditQuestionModal
								isOpen={isOpen}
								onClose={onClose}
								index={index}
								edit={handleEdit}
								question={question}
							/>
						</>
					}
					<ButtonOnlyIcon
						name='trash'
						h='32px'
						aria-label='Remover pergunta'
						onClick={remove}
					/>
				</HStack>
			</HStack>

			<QuestionComponent
				index={index}
				question={question}
				editable={true}
			/>
    </VStack>
  )
}

export const mapQuestionToForm = (question) => {
  const booleanToString = (value) => {
    return value ? 'Sim' : 'Não';
  }
  try {

    let options = question.options?.map(op => ({
      description: op.description,
      isIgnored: booleanToString(op.isIgnored),
      isPrerequisite: booleanToString(op.isPrerequisite),
    }));

    let gridRows = question.gridRows?.map(row => ({
      description: row.description,
      row_order: row.row_order,
    }));

    let gridColumns = question.options?.map(col => ({
      description: col.description,
    }));

    return [
      {
        // EG-41: a identidade da questão precisa atravessar o formulário.
        // Sem o id_question_template o front sabe o que a questão diz, mas não
        // QUAL linha do banco ela é — e a classificação individual grava por
        // id, fora do fluxo de versionamento. Reconstruir depois é impossível:
        // o save do template recria as questões com IDs novos.
        id_question_template: question.id_question_template ?? null,
        id_pillar: question.id_pillar ?? null,
        id_theme: question.id_theme ?? null,
        // GRI-02: o formulário guarda só os ids; o multiselect resolve código e
        // nome contra o catálogo. Sem carregar o que já está vinculado, abrir e
        // salvar a questão enviaria [] e DESVINCULARIA tudo — a substituição do
        // caminho individual não perdoa campo mal inicializado.
        gri_ids: (question.gri ?? []).map(
          (indicador) => indicador.id_gri_indicator
        ),
        code: question.code,
        title: question.questionTitleTemplate[0]?.description || '',
        type: question.type,
        index: question.index,
        previousYears: booleanToString(question.previous_year),
        isRequired: booleanToString(question.is_required),
        isCertified: booleanToString(question.is_certified),
        requestFiles: booleanToString(question.request_files),
        requestImages: booleanToString(question.request_images),
        hasAverage: booleanToString(question.has_average),
        hasSum: booleanToString(question.has_sum),
        hasHelper: booleanToString(question.helper.description || question.helper.url_video),
        helper: {
          description: question.helper.description,
          url_video: question.helper.url_video,
        },
        options: options,
        gridRows: gridRows || [],
        gridColumns: gridColumns || [],
      },
    ];
  } catch (e) {
    return [question];
  }
};

export const moveCardQuestions = (questions, direction, index) => {
	let updatedQuestions = [...questions];
	let emptyQuestion = updatedQuestions.splice(questions.length - 1, 1);

    const currentIndex = updatedQuestions.findIndex(field => field.index === index);

    if (currentIndex === -1) return questions;

    if (direction === 'up' && currentIndex > 0) {
        updatedQuestions[currentIndex].index = updatedQuestions[currentIndex].index - 1;
        updatedQuestions[currentIndex - 1].index = updatedQuestions[currentIndex - 1].index + 1;

    } else if (direction === 'down' && currentIndex < updatedQuestions.length - 1) {
        updatedQuestions[currentIndex].index = updatedQuestions[currentIndex].index + 1;
        updatedQuestions[currentIndex + 1].index = updatedQuestions[currentIndex + 1].index - 1;
    }

    return [...updatedQuestions, emptyQuestion];
};

export default EditQuestionCard;